import React from 'react';
import { Modal, ModalHeader, ModalBody, Alert, Button } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { IRootState } from 'app/shared/reducers';
import { SUCCESS, IND, ENP, ORG, LINK_TERM_OF_USE } from 'app/config/constants';
import { generateCaptcha } from '../../password-reset/password-reset.reducer';
import moment from 'moment';
import { connect } from 'react-redux';

export interface IAuthAddSmartCAProps extends StateProps, DispatchProps {
  modalShow: boolean;
  smartcaInfo: any;
  addAuthSmartCA: Function;
  errMessage: string;
  handleCloseModal: Function;
  captcha: any;
}

export interface IAuthAddSmartCAState {
  visible: boolean;
  color: string;
  message: string;
  userType: string;
}

export class AuthAddSmartCAInfo extends React.Component<IAuthAddSmartCAProps, IAuthAddSmartCAState> {
  state: IAuthAddSmartCAState = {
    visible: false,
    color: 'danger',
    message: '',
    userType: IND
  };

  componentDidMount(): void {}
  onDismiss = () => {
    this.setState({
      visible: false,
      message: ''
    });
  };
  handleValidSubmit = (event, values) => {
    this.props.smartcaInfo['email'] = values.email;
    this.props.smartcaInfo['captcha'] = values.captcha;
    this.props.addAuthSmartCA(this.props.smartcaInfo);
  };
  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  render() {
    const type = Storage.session.get('type');
    let name = 'Họ tên';
    if (this.state.userType && this.state.userType === ENP) {
      name = 'Tên doanh nghiệp';
    }
    if (this.state.userType && this.state.userType === ORG) {
      name = 'Tên tổ chức';
    }
    return (
      <div>
        <Modal
          isOpen={this.props.modalShow}
          toggle={this.props.handleCloseModal}
          centered={window.location === window.parent.location}
          backdrop="static"
          className="hide-border-bottom-modal"
        >
          <ModalHeader toggle={this.props.handleCloseModal} />
          <ModalBody>
            <div>
              <div>
                <h2 className="text-center font-weight-bold" id="register-title">
                  Đăng ký
                </h2>
                <p className="text-center txtContent">Chào mừng bạn đến với cổng dịch vụ công quốc gia</p>
                <Alert id="myAlert" color="danger" isOpen={this.props.errMessage !== '' ? true : false}>
                  {this.props.errMessage}
                </Alert>
              </div>

              <div className="row">
                <div className="col-12">
                  <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
                    {this.state.userType && this.state.userType === ENP ? (
                      <AvField
                        name="identity"
                        label={translate('global.form.tax.label')}
                        value={this.props.smartcaInfo ? this.props.smartcaInfo.uid : ''}
                        readOnly
                      />
                    ) : (
                      <AvField
                        name="identity"
                        label={translate('global.form.identity.label')}
                        value={this.props.smartcaInfo ? this.props.smartcaInfo.uid : ''}
                        readOnly
                      />
                    )}
                    <AvField name="fullName" label={name} value={this.props.smartcaInfo ? this.props.smartcaInfo.subjectCN : ''} readOnly />
                    <AvField
                      name="fromDate"
                      label={translate('global.form.fromDate.label')}
                      value={this.props.smartcaInfo ? moment(this.props.smartcaInfo.notBefore, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY') : ''}
                      readOnly
                    />
                    <AvField
                      name="toDate"
                      label={translate('global.form.toDate.label')}
                      value={this.props.smartcaInfo ? moment(this.props.smartcaInfo.notAfter, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY') : ''}
                      readOnly
                    />
                    <AvField
                      name="nameCA"
                      label={translate('global.form.nameCA.label')}
                      value={this.props.smartcaInfo ? this.props.smartcaInfo.issuerCN : ''}
                      readOnly
                    />
                    <AvField
                      name="email"
                      label={this.state.userType == ENP ? translate('global.form.email.require') : translate('global.form.email.label')}
                      placeholder={translate('global.form.email.placeholder')}
                      type="email"
                      validate={{
                        required: {
                          value: this.state.userType === ENP ? true : false,
                          errorMessage: translate('register.messages.validate.email.required')
                        },
                        email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                      }}
                    />
                    <label>{translate('global.form.code.label')}</label>
                    <div className="row">
                      <div className="col-6">
                        <AvField
                          id="input-captcha"
                          name="captcha"
                          label=""
                          placeholder="Nhập mã xác thực"
                          type="text"
                          validate={{
                            required: { value: true, errorMessage: 'Nhập mã xác thực' }
                          }}
                        />
                      </div>
                      <div className="col-4">
                        <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.props.captcha}`} alt="" />
                      </div>
                      <div className="col-2">
                        <img className="" src={require('../../../../images/header/refresh.svg')} onClick={this.invokeResetCaptcha} alt="" />
                      </div>
                    </div>
                    <div className="li">
                      Bằng cách nhấp vào Đăng ký, bạn đồng ý với{' '}
                      <a className="link" href={LINK_TERM_OF_USE} target="_blank">
                        Điều khoản, Chính sách chia sẻ thông tin
                      </a>{' '}
                      của chúng tôi
                    </div>
                    <Button
                      className="btn-register"
                      style={{ marginTop: '20px' }}
                      type="submit"
                      // disabled={this.state.disableButtonReg}
                      block
                    >
                      <Translate contentKey="register.form.button">Register</Translate>
                    </Button>
                  </AvForm>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã thêm thành công.'} /> */}
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({});

const mapDispatchToProps = { generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddSmartCAInfo);
